"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _featuredIcons = _interopRequireDefault(require("./featuredIcons"));
var _raqButton = _interopRequireDefault(require("./raqButton"));
var FeaturedCardFooter = function FeaturedCardFooter(_ref) {
  var serviceProviderId = _ref.serviceProviderId,
    postalCode = _ref.postalCode,
    awards = _ref.awards,
    ratings = _ref.ratings,
    starRating = _ref.starRating,
    listedSinceYear = _ref.listedSinceYear,
    LinkWrapperComponent = _ref.LinkWrapperComponent,
    raqUrl = _ref.raqUrl,
    dataTrackingPropsForRaqBtn = _ref.dataTrackingPropsForRaqBtn,
    singleFeaturedPro = _ref.singleFeaturedPro;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "featured-sp-card-footer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden-xs hidden-sm"
  }, /*#__PURE__*/_react["default"].createElement(_featuredIcons["default"], {
    postalCode: postalCode,
    starRating: starRating,
    awards: awards,
    ratings: ratings,
    listedSinceYear: listedSinceYear,
    customClass: "featured-icons",
    singleFeaturedPro: singleFeaturedPro
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden-md hidden-lg",
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_raqButton["default"], {
    serviceProviderId: serviceProviderId,
    customClass: "featured-raq-button",
    LinkWrapperComponent: LinkWrapperComponent,
    dataTrackingPropsForRaqBtn: dataTrackingPropsForRaqBtn,
    requestAQuoteUrl: raqUrl
  })));
};
FeaturedCardFooter.propTypes = {
  serviceProviderId: _propTypes["default"].number.isRequired,
  postalCode: _propTypes["default"].string.isRequired,
  starRating: _propTypes["default"].number.isRequired,
  awards: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    description: _propTypes["default"].string,
    images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      size: _propTypes["default"].string,
      url: _propTypes["default"].string
    }))
  })).isRequired,
  ratings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    starRating: _propTypes["default"].number
  })).isRequired,
  listedSinceYear: _propTypes["default"].string.isRequired,
  LinkWrapperComponent: _propTypes["default"].element,
  raqUrl: _propTypes["default"].string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  dataTrackingPropsForRaqBtn: _propTypes["default"].object,
  singleFeaturedPro: _propTypes["default"].bool.isRequired
};
FeaturedCardFooter.defaultProps = {
  LinkWrapperComponent: null,
  dataTrackingPropsForRaqBtn: {}
};
var _default = exports["default"] = FeaturedCardFooter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/featured/featuredCardFooter.js
// module id = 6446
// module chunks = 25